export default __webpack_public_path__ + "static/media/accomm_img_5.09426fc8.JPG";